



import { SignerListFilterTs } from './SignerListFilterTs';
export default class SignerListFilter extends SignerListFilterTs {}
